import { FC, ReactNode, useMemo } from 'react';
import { Table, TableBody, TableHead, TableRow } from '@mui/material';
import { ViewTableColumn, ViewTableProps } from './types';
import { StyledContainer } from './ViewTableStyles';
import ViewTableHeader from './ViewTableHeader';
import ViewTableData from './ViewTableData';

const buildHeaders = (columns: ViewTableColumn[]): ReactNode[] => {
  const headers: ReactNode[] = [];
  let index = 0;

  while (index < columns.length) {
    const column = columns[index];
    const colSpan = Math.max(1, column.colSpan ?? 1);
    const safeColSpan = Math.min(colSpan, columns.length - index);

    headers.push(
      <ViewTableHeader
        key={column.key}
        column={column}
        index={index}
        colSpan={safeColSpan}
        color={'#6C6C6C'}
      />,
    );

    index += safeColSpan;
  }

  return headers;
};

const ViewTable: FC<ViewTableProps> = ({ data, columns, fallbackValue = '-' }) => {
  const headerCells = useMemo(() => buildHeaders(columns), [columns]);

  return (
    <StyledContainer sx={{ border: '1px solid #737F86' }}>
      <Table>
        <TableHead>
          <TableRow>{headerCells}</TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {columns.map((col, colIndex) => (
                <ViewTableData
                  key={col.key}
                  row={row}
                  column={col}
                  index={colIndex}
                  isLastRow={rowIndex === data.length - 1}
                  fallback={fallbackValue}
                />
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </StyledContainer>
  );
};

export default ViewTable;
